import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { GetLocationMasterMainStore } from "../services/ItemManagementService";
import LocationMasterFilters from "./LocationMasterFilters";
import LocationMasterSearchResults from "./LocationMasterSearchResults";

// Location Master top tab (Delphi IMD0046 → frmIMM0051.qryIMLocation). IMLOCATION list (Module = IM) + the
// show-all reference sub-tabs (Open/Historical Transactions, Item Master, Item/Lot, Location Master).
function LocationMasterTab(props) {
  const accessToken = props.oidc?.user?.access_token;
  const currentUser = props.oidc?.user;
  const dynamicFormSetting = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const [dataSource, setDataSource] = useState(null);

  const searchData = (formFields) => {
    setDataSource(GetLocationMasterMainStore(accessToken, formFields || {}));
  };

  // Load once on mount (empty filter = all IM locations).
  useEffect(() => {
    setDataSource(GetLocationMasterMainStore(accessToken, {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  return (
    <div>
      <LocationMasterFilters currentUser={currentUser} DYNAMICFORMSETTING={dynamicFormSetting} searchData={searchData} />
      <LocationMasterSearchResults data={dataSource} accessToken={accessToken} />
    </div>
  );
}

function mapStateToProps(state) { return { oidc: state.oidc }; }
export default connect(mapStateToProps)(LocationMasterTab);
